/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconGitPullRequestDraft = createReactComponent("outline", "git-pull-request-draft", "IconGitPullRequestDraft", [["path", { "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M6 8v8", "key": "svg-3" }], ["path", { "d": "M18 11h.01", "key": "svg-4" }], ["path", { "d": "M18 6h.01", "key": "svg-5" }]]);

export { IconGitPullRequestDraft as default };
//# sourceMappingURL=IconGitPullRequestDraft.mjs.map
